/**
 * Wilson white-label palette and favicon shared between the dashboard and
 * account portal. App-specific wiring (chakra theme overrides, brand
 * detection, login gradient) lives in each app's `wilson-brand.tsx`.
 */
export const WILSON_PALETTE = {
  darkNeutral: '#16170F',
  accent: '#00ae8a',
  lightYellow: '#FDF7B9',
  coverBackground: '#91ebc9',
  peach: '#ffcda6',
} as const;

const WILSON_FAVICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle fill="${WILSON_PALETTE.coverBackground}" cx="16" cy="16" r="16"/><path fill="${WILSON_PALETTE.accent}" d="M24.2,9.1c1.4,0,2.2.8,2.2,2s-.9,2-2.2,2-2.2-.8-2.2-2,.9-2,2.2-2h0Z"/><path fill="${WILSON_PALETTE.darkNeutral}" d="M9.8,13.4l1.2,5,1.2-5h3.5l1.2,5,1.2-5h4.2l-3.1,9.5h-4l-1.3-4.7-1.3,4.7h-4l-3.1-9.5h4.2Z"/></svg>`;

export const wilsonFavicon = `data:image/svg+xml;utf8,${encodeURIComponent(WILSON_FAVICON_SVG)}`;
